module.exports = __webpack_public_path__ + "assets/dots.e8b9bf3b.svg";